import { Component, OnInit, Input } from '@angular/core';
import { Breadcrumb } from '../../models/breadcrumb';
import { IBreadcrumbsService } from '../../interfaces/breadcrumbs-service.interface';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent implements OnInit {

  @Input()
  breadcrumbsService: IBreadcrumbsService;

  constructor(
  ) {
  }

  ngOnInit() {
  }

  get hasActiveBreadcrumbs(): boolean {
    return this.breadcrumbsService ? this.breadcrumbsService.hasActiveBreadcrumbs : false;
  }

  get breadcrumbs(): Breadcrumb[] {
    return this.breadcrumbsService ? this.breadcrumbsService.breadcrumbs : [];
  }
}
